import { ActivityType } from '@zeus/index';

import ClickImage from '~/pages/components/game/activities-forms/click-image';
import ClickObject from '~/pages/components/game/activities-forms/click-object';
import Dialog from '~/pages/components/game/activities-forms/dialog';
import DialogImage from '~/pages/components/game/activities-forms/dialog-image';
import DragDrop from '~/pages/components/game/activities-forms/drag-drop';
import Frise from '~/pages/components/game/activities-forms/frise';
import Qcm from '~/pages/components/game/activities-forms/qcm';
import Qcu from '~/pages/components/game/activities-forms/qcu';
import Recap from '~/pages/components/game/activities-forms/recap';
import { TActivity } from '~/utils/airtable/types/types';

type IProps = {
  currentActivity: TActivity;
  nextActivity: () => void;
};

type TProps = IProps;

export function RenderActivity({ currentActivity, nextActivity }: TProps) {
  const props = {
    currentActivity,
    nextActivity,
  };

  switch (currentActivity.type) {
    case ActivityType.DIALOG: {
      return <Dialog {...props} />;
    }

    case ActivityType.DIALOG_IMAGE: {
      return <DialogImage {...props} />;
    }

    case ActivityType.CLICK_IMAGE: {
      return <ClickImage {...props} />;
    }

    case ActivityType.CLICK_OBJECT: {
      return <ClickObject {...props} />;
    }

    case ActivityType.DRAG_DROP: {
      return <DragDrop {...props} />;
    }

    case ActivityType.FRISE: {
      return <Frise {...props} />;
    }

    case ActivityType.QCM: {
      return <Qcm {...props} />;
    }

    case ActivityType.QCU: {
      return <Qcu {...props} />;
    }
    case ActivityType.RECAP: {
      return <Recap {...props} />;
    }

    default: {
      return null;
    }
  }

  return null;
}
